function validate_form() {
    $('.lesson_form').form({
        fields: {
            lesson_time: {
                identifier: 'lesson_time',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Время занятия должно быть заполнено'
                    }
                ]
            },
            lesson_date: {
                identifier: 'lesson_date',
                rules: [
                    {
                        type: 'empty',
                        prompt: 'Дата занятия должно быть заполнено'
                    }
                ]
            },
            value: {
                identifier: 'value',
                rules: [
                    {
                        type: 'integer[1..5]',
                        prompt: 'Оценка может быть от 1 до 5'
                    }
                ]
            },
            score: {
                identifier: 'score',
                rules: [
                    {
                        type: 'integer[0..100]',
                        prompt: 'Балл может быть от 0 до 100'
                    }
                ]
            }
        }
    });

    $('#reload_curriculum').on('click', function () {
        group = $(this).attr('data-group');
        gradebook = $(this).attr('data-gradebook');
        study_year = $(this).attr('data-study_year');
        discipline = $(this).attr('data-discipline');
        period = $(this).attr('data-period');
        //console.log(group + " - " + gradebook + " - " + study_year + " - " + discipline + " - " + period);

        $.ajax({
            url: "/study/change_curriculum/",
            type: "GET",
            data: {'group' : group,'gradebook' : gradebook, 'study_year' : study_year, 'discipline' : discipline, 'period' : period},
            dataType: "json",
            beforeSend: function () {
                $('#reload_curriculum').addClass('loading');
            },
            success: function (data) {
                $('#reload_curriculum').removeClass('loading');
                //console.log(data)
                $('#curriculum').text(data[1]);
                $('#message').append('<div class="ui ' + (data[0]? "info" : "negative") + ' message attached"><div class="content">' + data[2] + '</div></div>');
            }
        });
    });

}

document.addEventListener("turbolinks:load", validate_form);

function cleanForm() {
    $('#curriculum').empty();
    $('#students').empty();
}

function addStudents(group_id) {
    $.ajax({
        url: "/study/students/" + group_id,
        type: "GET",
        data: {},
        dataType: "json",
        success: function (data) {
            if (data.students !== null) {
                students = ''
                data.students.filter(function (item) {
                    students += `
                    <div class="item">
                        <img class="ui avatar image" src="${item.avatar_url}">
                        <div class="content">${item.surname} ${item.name} ${item.patronymic}</div>
                    </div>`;
                });
                html = `
                    <div class="ui divider"></div>
                    <div class="ui tiny header">Студенты</div>
                    <div class="ui list">
                        ${students}
                    </div>
                `
            }
            $('#students').html(html)
        },
        complete: function () {
        }
    });
}

function changeGroupid(id) {
    $('#dim').dimmer('show');
    cleanForm();
    addStudents(id)
    $.ajax({
        url: "/study/disciplines/" + id,
        type: "GET",
        data: {

        },
        dataType: "json",
        success: function(data) {
            if (data.disciplines !== null) {
                options = ''
                data.disciplines.filter(function(item) {
                    options += `<option value="${item.state_id}" data-state="${item.state_id}">${item.discipline.name} (${item.study_year} ${item.period})</option>`;
                });
                items = ''
                data.disciplines.filter(function(item) {
                    items += `<div class="item" data-value="${item.state_id}">${item.discipline.name} (${item.study_year} ${item.period})</div>`;
                });
                html = `
                <div class="field">
                <label for="study_gradebook_discipline_id">Дисциплина</label>
                <div class="ui fluid search selection dropdown">
                    <select id="disciplineid"
                            onchange="changeDisciplineid($('option:selected', this).attr('data-state'))"
                            name="state">
                        <option value="">выберите дисциплину</option>
                        ${options}
                    </select>
                    <i class="dropdown icon"></i>
                    <input class="search">
                    <div class="text">выберите дисциплину</div>
                    <div class="menu">
                        ${items}
                    </div>
                </div>
                </div>
            `
            }
            $('#discipline').html(html)
        },
        complete: function(){
            $('.ui.dropdown').dropdown();
            $('#dim').dimmer('hide');
        }
    });
}

function changeDisciplineid(id) {
    $('#dim').dimmer('show');
    $.ajax({
        url: "/study/curriculums/" + id,
        type: "GET",
        data: {},
        dataType: "json",
        success: function (data) {
            curriculum = `
              <div class="ui divider"></div>
              <div class="field">
                <label for="study_gradebook_study_year_id">Дисциплина</label>
                <input value="${data.discipline.id}" type="hidden" name="study_gradebook[discipline_id]">
                <div class="ui disabled input">
                  <input type="text" value="${data.discipline.name}">
                </div>
              </div>
              <div class="field">
                <label for="study_gradebook_study_year_id">Учебный год</label>
                <input value="${data.study_year.id}" type="hidden" name="study_gradebook[study_year_id]">
                <div class="ui disabled input">
                  <input type="text" value="${data.study_year.name}">
                </div>
              </div>

              <div class="field">
                <label for="study_gradebook_period">Семестр</label>
                <input value="${data.state.period}" type="hidden" name="study_gradebook[period]">
                <div class="ui disabled input">
                  <input type="text" value="${data.state.period}">
                </div>
              </div>
              <div class="field">
                <label for="study_gradebook_curriculum_id">Учебный план</label>
                <input value="${data.curriculum.id}" type="hidden" name="study_gradebook[curriculum_id]">
                <div class="ui disabled input">
                  <input type="text" value="${data.curriculum.name}">
                </div>
              </div>
              <div class="ui checkbox checked">
                <input name="study_gradebook[rating]" type="hidden" value="0">
                <input type="checkbox" value="" name="study_gradebook[rating]" tabindex="0" class="hidden">
                <label>Использовать балльно-рейтинговую систему оценки</label>
              </div>

            `
            $('#curriculum').html(curriculum)
        },
        complete: function () {
            $('.ui.dropdown').dropdown();
            $('.ui.checkbox').checkbox();
            $('#dim').dimmer('hide');
        }
    });
}
document.addEventListener("turbolinks:load", function() {
    $('body').on('cocoon:after-insert', function (e, insertedItem) {
        $('.ui.dropdown').dropdown();

        $('.ui.search')
            .search({
                minCharacters : 2,
                apiSettings   : {
                    url       : '/study/gradebooks/autocomplete_person_surname?term={query}',
                    onResponse : function(serverResponse) {
                        var response = {
                                results: []
                            };

                        if(serverResponse[0] == undefined){
                            response.results.push({
                                title : "Нет результатов"
                            });
                        }else{
                            $.each(serverResponse, function(index, item) {
                                if(item.value != undefined) {
                                    response.results.push({
                                        title: item.value,
                                        id: item.id
                                    });
                                }
                            });
                        }

                        return response;
                    }
                },
                onSelect: function(item) {
                    $(this).next('input:hidden').val(item.id)
                }
            });
    });
});
